module.exports = __webpack_public_path__ + "img/wulian.0257cfb1.png";